import { render, staticRenderFns } from "./scorerecordlist.vue?vue&type=template&id=50352a74&scoped=true"
import script from "./scorerecordlist.vue?vue&type=script&lang=js"
export * from "./scorerecordlist.vue?vue&type=script&lang=js"
import style0 from "./scorerecordlist.vue?vue&type=style&index=0&id=50352a74&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50352a74",
  null
  
)

export default component.exports